import React, { useState, useEffect } from "react";
import logo from "../assets/NJOsB.jpeg";

// Icône panier SVG
const CartIcon = (
    <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h7.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
);

// Icône sac SVG
const BagIcon = (
    <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path d="M6 7V6a6 6 0 1 1 12 0v1"/>
        <rect x="3" y="7" width="18" height="14" rx="2"/>
        <path d="M16 11a4 4 0 0 1-8 0"/>
    </svg>
);

function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
    );
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoint]);
    return isMobile;
}

const Navbar = () => {
    const [toggleMenu, setToggleMenu] = useState(false);
    const [hovered, setHovered] = useState(null);
    const currentPath = window.location.pathname;
    const isMobile = useIsMobile();

    const links = [
        { href: "/", label: "Accueil" },
        { href: "/parfums", label: "Parfums" },
        { href: "/about", label: "À propos" },
        { href: "/contact", label: "Contact" },
        { href: "/panier", label: "Panier", icon: BagIcon }, 
    ];

    return (
        <nav style={styles.navbar}>
            <div style={styles.logoContainer}>
                <a href="/" style={styles.logoLink}>
                    <img src={logo} alt="logo" style={styles.logo} />
                </a>
            </div>
            {/* Liens visibles seulement sur desktop */}
            {!isMobile && (
                <div style={styles.linksContainer}>
                    {links.map(link => (
                        <a
                            key={link.href}
                            href={link.href}
                            style={{
                                ...styles.link,
                                ...(currentPath === link.href ? styles.activeLink : {}),
                                ...(hovered === link.href && currentPath !== link.href ? styles.linkHover : {})
                            }}
                            onMouseEnter={() => setHovered(link.href)}
                            onMouseLeave={() => setHovered(null)}
                        >
                            {link.icon ? link.icon : link.label}
                        </a>
                    ))}
                </div>
            )}
            {/* Icône menu burger visible sur mobile */}
            {isMobile && (
                <div style={styles.menuIcon} onClick={() => setToggleMenu(!toggleMenu)}>
                    {toggleMenu ? "✖" : "☰"}
                </div>
            )}
            {/* Menu déroulant mobile */}
            {isMobile && toggleMenu && (
                <div style={styles.mobileMenu}>
                    {links.map(link => (
                        <a
                            key={link.href}
                            href={link.href}
                            style={{
                                ...styles.mobileLink,
                                ...(currentPath === link.href ? styles.activeLink : {}),
                                ...(hovered === link.href && currentPath !== link.href ? styles.linkHover : {})
                            }}
                            onMouseEnter={() => setHovered(link.href)}
                            onMouseLeave={() => setHovered(null)}
                            onClick={() => setToggleMenu(false)}
                        >
                            {link.icon ? link.icon : link.label}
                        </a>
                    ))}
                </div>
            )}
        </nav>
    );
};

const styles = {
    navbar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 0px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        gap: "24px",
        position: "relative",
    },
    logoContainer: {
        flex: 1,
    },
    logoLink: {
        textDecoration: "none",
    },
    logo: {
        height: "87px",
        alignItems: "center",
    },
    linksContainer: {
        flex: 2,
        display: "flex",
        justifyContent: "center",
        gap: "20px",
    },
    link: {
        textDecoration: "none",
        color: "#333",
        fontSize: "16px",
        fontWeight: "500",
        transition: "color 0.3s, border-bottom 0.3s",
        paddingBottom: "4px",
        borderBottom: "2px solid transparent",
        cursor: "pointer",
    },
    activeLink: {
        borderBottom: "2px solid #000",
        color: "#000",
    },
    linkHover: {
        borderBottom: "2px solid #000",
    },
    menuIcon: {
        display: "block",
        fontSize: "32px",
        cursor: "pointer",
        zIndex: 10,
        padding: "0 16px",
    },
    mobileMenu: {
        position: "absolute",
        top: "100%",
        right: "0",
        backgroundColor: "#fff",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        padding: "10px 20px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        zIndex: 9,
        minWidth: "160px",
    },
    mobileLink: {
        textDecoration: "none",
        color: "#333",
        fontSize: "16px",
        fontWeight: "500",
        transition: "color 0.3s, border-bottom 0.3s",
        borderBottom: "2px solid transparent",
        paddingBottom: "4px",
        cursor: "pointer",
    },
};

export default Navbar;